import React from 'react';
import styles from './selling-offers-skeleton.module.scss';

const SellingOffersProductCardSkeleton: React.FC = () => {
  return (
    <div className={`${styles.sellingOffersSkeleton__productCard} ssc`}>
      <div className={styles.sellingOffersSkeleton__productCard__img}>
        <div className="ssc-square"></div>
      </div>

      <div className={styles.sellingOffersSkeleton__productCard__details}>
        <div className="ssc-line w-90"></div>
        <div className="ssc-line w-80"></div>
        <div className="ssc-line w-30"></div>
        <div className="ssc-line w-80"></div>
        <div className="ssc-line w-40"></div>
      </div>
    </div>
  );
};

export default SellingOffersProductCardSkeleton;
